import type { Seat } from '@cineamo/ui/src/seat-map/typedefs';

// Relative `.ts` import (allowed by packages/ui/tsconfig.json, same as apps/signage/src/board/*):
// an `@cineamo/*` value import would not resolve under node --test.
import { NON_SELECTABLE_SEAT_TYPES } from './scene-geometry.ts';

export type SeatColorOptions = {
    selectedSeatColor: string;
    errorColor: string;
    seatColorsByCategory: Record<string, string>;
    fallbackColor: string;
};

export const LOCKED_SEAT_COLOR = '#5b5d6e';
export const NON_SELECTABLE_SEAT_COLOR = '#9a9cab';

export function seatColor(
    seat: Pick<Seat, 'isSelected' | 'isLocked' | 'isError' | 'category' | 'type'>,
    options: SeatColorOptions
): string {
    if (seat.isError) return options.errorColor;
    if (seat.isSelected) return options.selectedSeatColor;
    if (seat.isLocked) return LOCKED_SEAT_COLOR;
    if (NON_SELECTABLE_SEAT_TYPES.has(seat.type)) return NON_SELECTABLE_SEAT_COLOR;
    const name = seat.category?.name ?? '';
    return (
        (Object.hasOwn(options.seatColorsByCategory, name) ? options.seatColorsByCategory[name] : undefined) ??
        options.fallbackColor
    );
}

/** Whether a free seat is painted in a price category color (the legend entry) rather than the fallback. */
export function hasCategoryColor(seat: Pick<Seat, 'category'>, options: SeatColorOptions): boolean {
    return Object.hasOwn(options.seatColorsByCategory, seat.category?.name ?? '');
}
